"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLTILaunchArgs = exports.DefaultLTILaunch = void 0;
var lti_launch_1 = require("./lti-launch");
var get_component_1 = require("../../shared/helpers/get-component");
// default args
var DefaultLTILaunchArgs = {
    url: 'il-consumer.com',
};
exports.DefaultLTILaunchArgs = DefaultLTILaunchArgs;
// common components
var DefaultLTILaunch = (0, get_component_1.getComponent)(lti_launch_1.LTILaunch, DefaultLTILaunchArgs);
exports.DefaultLTILaunch = DefaultLTILaunch;
